import { css } from 'linaria';
import { Button } from '@pocket/web-ui';
import Link from 'next/link';
const linkStyles = "lqd0tjb";
export const Links = ({
  toggleDevMode
}) => {
  const links = [{
    title: 'Account',
    description: 'New account page for users to manage accounts',
    src: '/account'
  }];
  return <div className={linkStyles}>
      <h6>Links in progress</h6>
      {links.length ? links.map(link => <Link href={link.src} key={link.title}>
              <a onClick={toggleDevMode} className="link">
                <div className="title">{link.title}</div>
                <div className="description">{link.description}</div>
              </a>
            </Link>) : null}
    </div>;
};

require("./links.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./links.js");